import { render, staticRenderFns } from "./new-parametre-prix-modal.vue?vue&type=template&id=71ff3fd0&scoped=true"
import script from "./new-parametre-prix-modal.vue?vue&type=script&lang=js"
export * from "./new-parametre-prix-modal.vue?vue&type=script&lang=js"
import style0 from "./new-parametre-prix-modal.vue?vue&type=style&index=0&id=71ff3fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff3fd0",
  null
  
)

export default component.exports